import { useState } from "react";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ShopHero from "./components/ShopHero";
import FilterBar from "./components/FilterBar";
import ProductGrid from "./components/ProductGrid";

export default function Shop() {
  useSmoothScroll();
  const [activeCategory, setActiveCategory] = useState("All");

  return (
    <div className="min-h-screen bg-bone text-ink">
      <Navbar />
      <main>
        <ShopHero />
        <FilterBar
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />
        <ProductGrid />
      </main>
      <Footer />
    </div>
  );
}